// Bootstrap tooltips read an element's `title` once, when created, then move
// it to `data-bs-original-title`. Vue doesn't know that: when a bound
// `:title` changes it writes `title` back, so the browser shows its own
// native tooltip with the new text while Bootstrap's still shows the old one
// (e.g. "Select a route first" after a route was selected). Run this after
// each render to hand any rewritten title to its tooltip.

interface TooltipLike {
  setContent(content: Record<string, string>): void;
}

export function syncTooltipTitles(
  root: ParentNode | null | undefined,
  tooltipFor: (el: Element) => TooltipLike | null | undefined
): void {
  if (!root) return;
  root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    const title = el.getAttribute('title');
    if (title == null) return;
    el.setAttribute('data-bs-original-title', title);
    el.removeAttribute('title');
    tooltipFor(el)?.setContent({ '.tooltip-inner': title });
  });
}
